import SearchIcon from '~/assets/icons/Search';

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
};

const Search = ({ onChange, value }: Props) => {
  return (
    <label className="flex w-full items-center gap-3 border-b border-grey-divide p-4 text-sm">
      <span className="flex size-4 shrink-0 items-center justify-center">
        <SearchIcon height={16} width={16} />
      </span>
      <input
        className="w-full bg-transparent outline-none placeholder:text-grey-hide"
        placeholder="Search"
        onChange={onChange}
        value={value}
      />
    </label>
  );
};

export default Search;
